"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _utils = require("../../utils");
var _reactBootstrap = require("react-bootstrap");
var _linkFieldSrc = require("../../lib/linkFieldSrc");
var _richTextField = require("../../lib/richTextField");
var _CTAButton = _interopRequireDefault(require("../../components/CTAButton"));
var _lodash = require("lodash");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 *  A react component to create featured stats card
 *
 * @param {object} props The properties passed into the object
 * @param {object} props.rendering Fields to render
 * @param {object} props.rendering.fields Fields
 *
 * @returns {React.ReactElement} Featured Stats Card
 */
function FeaturedStats(props) {
  if (!props.rendering.fields) return null;
  var extractedFields = (0, _utils.extractFieldsFn)(props);
  var {
    linkUrl,
    linkTarget
  } = (0, _linkFieldSrc.linkFieldSrc)(extractedFields.Link.value);
  var hideTitleRow = (0, _lodash.isEmpty)(extractedFields.Title.value) && (0, _lodash.isEmpty)(extractedFields.PreviewText.value);
  var hideCtaRow = (0, _lodash.isEmpty)(extractedFields.Text.value) && (0, _lodash.isEmpty)(extractedFields.Callout.value);
  return /*#__PURE__*/_react.default.createElement("div", {
    id: (0, _utils.getComponentContentId)(props.rendering.dataSource),
    className: "app-container"
  }, !hideTitleRow && /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-text-center"
  }, !(0, _lodash.isEmpty)(extractedFields.Title.value) && /*#__PURE__*/_react.default.createElement("p", {
    className: "data-sm"
  }, (0, _richTextField.parseHTML)(extractedFields.Title)), !(0, _lodash.isEmpty)(extractedFields.PreviewText.value) && /*#__PURE__*/_react.default.createElement("p", null, (0, _richTextField.parseHTML)(extractedFields.PreviewText))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, extractedFields.Stats.map((stat, key) => {
    return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
      md: (0, _utils.columnWidth)(extractedFields.Stats.length, 3),
      key: key
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "mm-content-object--stats"
    }, !(0, _lodash.isEmpty)(stat.fields.Eyebrow.value) && /*#__PURE__*/_react.default.createElement("p", {
      className: "eyebrow"
    }, (0, _richTextField.parseHTML)(stat.fields.Eyebrow)), /*#__PURE__*/_react.default.createElement("p", {
      className: "data-xl"
    }, (0, _richTextField.parseHTML)(stat.fields.Stats)), /*#__PURE__*/_react.default.createElement("p", {
      className: "mm-text-center"
    }, (0, _richTextField.parseHTML)(stat.fields.StatsInfo))));
  }))), !hideCtaRow && /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-text-center stats-footer"
  }, !(0, _lodash.isEmpty)(extractedFields.Callout.value) && /*#__PURE__*/_react.default.createElement("p", {
    className: "caption"
  }, (0, _richTextField.parseHTML)(extractedFields.Callout)), /*#__PURE__*/_react.default.createElement(_CTAButton.default, {
    buttonType: extractedFields.ButtonType.value,
    href: linkUrl,
    label: extractedFields.Text.value,
    target: linkTarget,
    icon: extractedFields.ctaIcon.value,
    iconDirection: extractedFields.ctaIconPlacement.value,
    dataId: extractedFields.ctaDataId.value
  })));
}
var _default = exports.default = FeaturedStats;